const apiUrl = process.env.REACT_APP_API_URL;

const getJourneyQuestions = (token, id, stage, cb) => {
    fetch(`${apiUrl}/journeyquestions/${id}?section=${stage}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getJourneyQuestions;
